/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 12L22 12M9 2V22M15 2V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M9 2H15.6C17.8402 2 18.9603 2 19.816 2.43597C20.5686 2.81947 21.1805 3.43139 21.564 4.18404C22 5.03969 22 6.15979 22 8.4V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H9V2Z"
				fill="currentColor"
			/>
			<path
				d="M9 12L22 12M9 2V22M15 2V22M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.25 2.85C15.25 2.28995 15.25 2.00992 15.141 1.79601C15.0451 1.60785 14.8922 1.45487 14.704 1.35899C14.4901 1.25 14.2101 1.25 13.65 1.25H10.35C9.78995 1.25 9.50992 1.25 9.29601 1.35899C9.10785 1.45487 8.95487 1.60785 8.85899 1.79601C8.75 2.00992 8.75 2.28995 8.75 2.85V9.65C8.75 10.2101 8.75 10.4901 8.85899 10.704C8.95487 10.8922 9.10785 11.0451 9.29601 11.141C9.50992 11.25 9.78995 11.25 10.35 11.25H13.65C14.2101 11.25 14.4901 11.25 14.704 11.141C14.8922 11.0451 15.0451 10.8922 15.141 10.704C15.25 10.4901 15.25 10.2101 15.25 9.65V2.85ZM15.25 14.35C15.25 13.7899 15.25 13.5099 15.141 13.296C15.0451 13.1078 14.8922 12.9549 14.704 12.859C14.4901 12.75 14.2101 12.75 13.65 12.75H10.35C9.78995 12.75 9.50992 12.75 9.29601 12.859C9.10785 12.9549 8.95487 13.1078 8.85899 13.296C8.75 13.5099 8.75 13.7899 8.75 14.35V21.15C8.75 21.7101 8.75 21.9901 8.85899 22.204C8.95487 22.3922 9.10785 22.5451 9.29601 22.641C9.50992 22.75 9.78995 22.75 10.35 22.75H13.65C14.2101 22.75 14.4901 22.75 14.704 22.641C14.8922 22.5451 15.0451 22.3922 15.141 22.204C15.25 21.9901 15.25 21.7101 15.25 21.15V14.35ZM17.75 22.75C17.1977 22.75 16.75 22.3023 16.75 21.75V14.35C16.75 13.7899 16.75 13.5099 16.859 13.296C16.9549 13.1078 17.1078 12.9549 17.296 12.859C17.5099 12.75 17.7899 12.75 18.35 12.75H21.15C21.7101 12.75 21.9901 12.75 22.204 12.859C22.3922 12.9549 22.5451 13.1078 22.641 13.296C22.75 13.5099 22.75 13.7899 22.75 14.35V17.75C22.75 20.5114 20.5114 22.75 17.75 22.75ZM18.35 11.25C17.7899 11.25 17.5099 11.25 17.296 11.141C17.1078 11.0451 16.9549 10.8922 16.859 10.704C16.75 10.4901 16.75 10.2101 16.75 9.65V2.25C16.75 1.69772 17.1977 1.25 17.75 1.25C20.5114 1.25 22.75 3.48858 22.75 6.25V9.65C22.75 10.2101 22.75 10.4901 22.641 10.704C22.5451 10.8922 22.3922 11.0451 22.204 11.141C21.9901 11.25 21.7101 11.25 21.15 11.25H18.35ZM1.25 6.25C1.25 3.48858 3.48858 1.25 6.25 1.25C6.80228 1.25 7.25 1.69772 7.25 2.25V21.75C7.25 22.3023 6.80228 22.75 6.25 22.75C3.48858 22.75 1.25 20.5114 1.25 17.75V6.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9 12L22 12M9 18V2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497M15 2V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9 12L22 12M9 2V22M15 2V22M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g opacity="0.32">
				<path
					d="M13.65 1.25H10.35C9.78995 1.25 9.50992 1.25 9.29601 1.35899C9.10785 1.45487 8.95487 1.60785 8.85899 1.79601C8.75 2.00992 8.75 2.28995 8.75 2.85V9.65C8.75 10.2101 8.75 10.4901 8.85899 10.704C8.95487 10.8922 9.10785 11.0451 9.29601 11.141C9.50992 11.25 9.78995 11.25 10.35 11.25H13.65C14.2101 11.25 14.4901 11.25 14.704 11.141C14.8922 11.0451 15.0451 10.8922 15.141 10.704C15.25 10.4901 15.25 10.2101 15.25 9.65V2.85C15.25 2.28995 15.25 2.00992 15.141 1.79601C15.0451 1.60785 14.8922 1.45487 14.704 1.35899C14.4901 1.25 14.2101 1.25 13.65 1.25Z"
					fill="currentColor"
				/>
				<path
					d="M10.35 12.75H13.65C14.2101 12.75 14.4901 12.75 14.704 12.859C14.8922 12.9549 15.0451 13.1078 15.141 13.296C15.25 13.5099 15.25 13.7899 15.25 14.35V21.15C15.25 21.7101 15.25 21.9901 15.141 22.204C15.0451 22.3922 14.8922 22.5451 14.704 22.641C14.4901 22.75 14.2101 22.75 13.65 22.75H10.35C9.78995 22.75 9.50992 22.75 9.29601 22.641C9.10785 22.5451 8.95487 22.3922 8.85899 22.204C8.75 21.9901 8.75 21.7101 8.75 21.15V14.35C8.75 13.7899 8.75 13.5099 8.85899 13.296C8.95487 13.1078 9.10785 12.9549 9.29601 12.859C9.50992 12.75 9.78995 12.75 10.35 12.75Z"
					fill="currentColor"
				/>
				<path
					d="M16.75 21.75V14.35C16.75 13.7899 16.75 13.5099 16.859 13.296C16.9549 13.1078 17.1078 12.9549 17.296 12.859C17.5099 12.75 17.7899 12.75 18.35 12.75H21.15C21.7101 12.75 21.9901 12.75 22.204 12.859C22.3922 12.9549 22.5451 13.1078 22.641 13.296C22.75 13.5099 22.75 13.7899 22.75 14.35V17.75C22.75 20.5114 20.5114 22.75 17.75 22.75C17.1977 22.75 16.75 22.3023 16.75 21.75Z"
					fill="currentColor"
				/>
				<path
					d="M16.75 9.65V2.25C16.75 1.69772 17.1977 1.25 17.75 1.25C20.5114 1.25 22.75 3.48858 22.75 6.25V9.65C22.75 10.2101 22.75 10.4901 22.641 10.704C22.5451 10.8922 22.3922 11.0451 22.204 11.141C21.9901 11.25 21.7101 11.25 21.15 11.25H18.35C17.7899 11.25 17.5099 11.25 17.296 11.141C17.1078 11.0451 16.9549 10.8922 16.859 10.704C16.75 10.4901 16.75 10.2101 16.75 9.65Z"
					fill="currentColor"
				/>
			</g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 6.25C1.25 3.48858 3.48858 1.25 6.25 1.25C6.80228 1.25 7.25 1.69772 7.25 2.25V21.75C7.25 22.3023 6.80228 22.75 6.25 22.75C3.48858 22.75 1.25 20.5114 1.25 17.75V6.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
